import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { SessionHelper } from '@src/app/helpers/sessionHelper';
import { environment } from '@src/environments/environment';
import { PersonOrganization } from '../model/personorganization';
import { Person } from '../model/person';
import { Orgsettings } from '../model/orgsettings';
import { Orgstyle } from '@src/app/helpers/uieventhub/model/orgstyle';
import { Organization } from '../model/Organization';

const httpOptions = {
  headers: new HttpHeaders({
    'Content-Type': 'application/json',
    'Authorization': sessionStorage.getItem('id_token')
  })
}

@Injectable({
  providedIn: 'root'
})
export class TopNavService {

  personUrl:string = environment.apiUrl+'/organization/'+SessionHelper.getChoosenOrg()+'/person/';
  
  constructor(private http:HttpClient) { }

  logout(){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.post(environment.apiUrl+'/api/auth/logout', {}, httpOptions);
  }
  getPersonOrgList(personId:string){

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    var urlCombo = this.personUrl+personId+'/organization/mylist';

    return this.http.get<PersonOrganization[]>(urlCombo,httpOptions);
  }
  getPerson(personId:string) {
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    var urlCombo = `${this.personUrl}${personId}`;
    return this.http.get<Person>(urlCombo,httpOptions);
  }
  getOrg(orgId:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.get<Orgsettings>(environment.apiUrl+'/organization/'+orgId,httpOptions)
  }
  // PUT /notification/person/{personId}
  storeSubscription(sub:string,personId:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.put(environment.apiUrl+'/notification/person/'+personId,sub,httpOptions)
 
  }

  getPersonAuth(orgId:string, personId:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    return this.http.get<any>(environment.apiUrl+'/organization/'+orgId+'/person/'+personId+'/auth',httpOptions)
  }
  refreshPersonAuth(orgId:string,personId:string){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }
    //PATCH    /person/{personId}/orguser/refreshauth	worktrest	auth_{userId}	
    return this.http.patch<any>(environment.apiUrl+'/organization/'+orgId+'/person/'+personId+'/orguser/refreshauth','',httpOptions)
  }
  getOrgList(){

    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json'
      }),
      withCredentials: true
    }

    return this.http.get<Organization[]>(environment.apiUrl+'/organization/list',httpOptions);
  }
}
